@if (agentType() === 'mandataire') {
  <div class="space-y-4">
    <div class="space-y-2">
      <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider block">
        Sélectionner votre réseau de mandataires
      </span>
      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-select
          aria-label="Sélectionner votre réseau de mandataires"
          placeholder="Sélectionnez votre réseau de mandataires..."
          [value]="isCustomNetwork() ? 'Autre' : network()"
          (valueChange)="onNetworkSelected($event)"
        >
          @for (net of knownNetworks; track net) {
            <mat-option [value]="net">{{ net }}</mat-option>
          }
        </mat-select>
        <mat-icon matPrefix class="mr-3 text-neutral-8">groups</mat-icon>
      </mat-form-field>
    </div>

    @if (isCustomNetwork()) {
      <div class="space-y-2 animate-in fade-in duration-200">
        <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider block">
          Précisez votre réseau ou agence de rattachement
        </span>
        <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
          <input
            aria-label="Précisez votre réseau ou agence de rattachement"
            matInput
            [value]="customNetworkName()"
            (input)="onCustomNetworkChange($any($event.target).value)"
            placeholder="Ex : Réseau Régional Immo, Cabinet X..."
          />
          <mat-icon matPrefix class="mr-3 text-neutral-8">edit</mat-icon>
        </mat-form-field>
      </div>
    }
  </div>
} @else {
  <div class="space-y-2">
    <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider block">
      Nom commercial de l'agence
    </span>
    <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
      <input
        aria-label="Nom commercial de l'agence"
        matInput
        [value]="network()"
        (input)="onAgencyNameChange($any($event.target).value)"
        placeholder="Ex : Cabinet Immobilier Saint-Michel, Stéphane Plaza Biarritz..."
      />
      <mat-icon matPrefix class="mr-3 text-neutral-8">business</mat-icon>
    </mat-form-field>
  </div>
}
